import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/cabral.ro/cabral.ro/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/cabral.ro/cabral.ro/layouts/empty.vue").then(m => m.default || m))
}